<template>
  <div class="w-100 h-100">
    <div style="height: 30px; position: absolute; z-index: 1; left: 0; right: 0; transform: translateY(20px);" v-if="isRouteFullscreen">
      <div class="svgs" style="float: right;">
        <svg @click="$router.push('/fullscreen/service')" style="margin-right: -20px;" t="1751610347433" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1749" width="60" height="30"><path d="M598.361605 38.378364v198.288215H962.956065c38.378364 0 63.96394 25.585576 63.96394 63.963941v422.162006c0 38.378364-25.585576 63.96394-63.96394 63.96394H598.361605v198.288215c0 6.396394-6.396394 19.189182-12.792788 25.585576-12.792788 12.792788-38.378364 19.189182-51.171152 6.396394l-511.711523-454.143976-6.396394-6.396394c-25.585576-25.585576-19.189182-63.96394 6.396394-89.549517l511.711523-454.143976c12.792788-6.396394 19.189182-12.792788 25.585576-12.792788 25.585576 0 38.378364 19.189182 38.378364 38.378364z" p-id="1750"></path></svg>
        <svg @click="$router.push('/fullscreen/bigData')" t="1751608233199" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1468" width="60" height="30"><path d="M466.052637 0c6.384283 0 12.768565 6.384283 25.53713 12.768565l510.742616 453.284072c25.537131 25.537131 31.921413 63.842827 6.384283 89.379957l-6.384283 6.384283-510.742616 453.284071c-12.768565 12.768565-38.305696 12.768565-51.074261-6.384282-6.384283-6.384283-12.768565-19.152848-12.768565-25.537131v-197.912764H63.842827c-38.305696 0-63.842827-25.537131-63.842827-63.842827V300.061287c0-38.305696 25.537131-63.842827 63.842827-63.842827h363.904114V38.305696c0-19.152848 12.768565-38.305696 38.305696-38.305696z" p-id="1469"></path></svg>
      </div>
    </div>
    <div class="container" style="position: relative;" :style="{ fontSize }">
      <div class="header">
        <div class="header-inner">
          <template v-if="lang === 'en'">
            <dv-decoration-10 style="width: 30%; height: 5px;" />
            <dv-decoration-8 :color="['#54C0F9', 'transparent']" style="width: 12%;height: .4167rem;" />
            <div class="title" style="width: 16%">
              <h1 style="text-align: center; height: .2083rem; margin: .1042rem 0; font-size: .2917rem; color: #fff; font-weight: 600; line-height: .2083rem;">Deman Warning List</h1>
              <dv-decoration-6 style="width:100%; height: 7px; margin-top: .2083rem;" />
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54C0F9', 'transparent']" style="width: 12%; height: .4167rem;" />
            <dv-decoration-10 style="width:30%; height:5px; transform: rotate(180deg)" />
          </template>
          <template v-else>
            <dv-decoration-10 style="width: 30%; height: 5px;" />
            <dv-decoration-8 :color="['#54C0F9', 'transparent']" style="width: 12%;height: .4167rem;" />
            <div class="title" style="width: 16%">
              <h1 style="text-align: center; height: .2083rem; margin: .1042rem 0; font-size: .2917rem; color: #fff; font-weight: 600; line-height: .2083rem;">德曼提前预警一览表</h1>
              <dv-decoration-6 style="width:100%; height: 7px; margin-top: .2083rem;" />
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54C0F9', 'transparent']" style="width: 12%; height: .4167rem;" />
            <dv-decoration-10 style="width:30%; height:5px; transform: rotate(180deg)" />
          </template>
        </div>
      </div>
      <a-menu v-model="currentType" mode="horizontal">
        <a-menu-item
          v-for="item in selectedWarningType"
          :key="item.type"
        >
          {{item[lang]}}
        </a-menu-item>
      </a-menu>
      <a-icon type="setting" style="color: #ddd; font-size: 30px; position: absolute; right: 1%; top: 74px; cursor: pointer" @click="openSetting" />
      <!--  @mouseenter="stopScroll" @mouseleave="startScroll" -->
      <div class="content">
        <table ref="container">
          <thead>
            <th :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-for="column in columns" :key="column.key">
              <a-tooltip v-if="column.tooltip && column[lang].length > 9" :getPopupContainer="(triggerNode) => triggerNode.parentNode">
                <template slot="title">
                  {{column[lang]}}
                </template>
                {{column[lang]}}
              </a-tooltip>
              <template v-else>
                {{column[lang]}}
              </template>
            </th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in currentData" :key="item.id" :class="{ deep: index % 2 !== 0, shallow: index % 2 === 0}">
              <template v-for="column in columns">
                <td :class="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-if="['percentage', 'powerAB', 'temp', 'pres', 'elec'].includes(column.key)" :key="column.key + data.id">{{(item[column.key] * 100).toFixed(0)}}%</td>
                <td :key="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-else-if="column.field">{{ item[column.field[0]] ? item[column.field[0]][column.field[1]] : '' }}</td>
                <td :class="column.key" :style="{ width: column.width ? column.width + 'px' : 'auto'}" v-else :key="column.key + data.id">{{item[column.key]}}</td>
              </template>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <a-modal v-model="visible" :width="lang === 'en' ? 850 : 800" :title="`${$t('overview.list')}${$t('overview.listContent.setting')}`" @ok="saveSetting" @cancel="handleCancel">
      <a-form-model :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" :style="`padding-right: ${ lang === 'en' ? '30px' : '10px' }`">
        <a-form-model-item :label="`${$t('overview.listContent.pageGap')}(s)`">
          <a-input-number v-model="form.speed" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.rows')}`">
          <a-input-number v-model="form.rowsPP" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.total')}`" :extra="`* ${$t('overview.listContent.extra')}`">
          <a-input-number v-model="form.rows" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.replaceWord')}`">
          <a-input v-model="form.replaceWord" style="width: 100%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.replaceRange')}`">
          <a-input-number v-model="form.start" style="width: 30%" /> ~
          <a-input-number v-model="form.end" style="width: 30%" />
        </a-form-model-item>
        <a-form-model-item :label="`${$t('overview.listContent.type')}`">
          <!-- <a-select
            mode="tags"
            v-model="form.types"
          >
            <a-select-option
              v-for="w in warningType"
              :key="w.type"
            >
              {{ w.name }}
            </a-select-option>
          </a-select> -->
          <a-checkbox-group
            v-model="types"
            name="checkboxgroup"
          >
            <a-row :gutter="24">
              <a-col
                v-for="w in warningType"
                :span="lang === 'en' ? 12 : 8"
                :key="w.type"
              >
                <a-checkbox :value="w.type">
                  {{ w[lang] }}
                </a-checkbox>
              </a-col>
            </a-row>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :label="$t('overview.listContent.fontSize')">
          <a-input-number v-model="form.fontSize" style="width: 100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import warningType from './data'
import { getWarnData } from '@/api/monitor'
import { getMenusOfCurrentUser } from '@/api/auth/menu'

export default {
  data() {
    return {
      warningType: [],
      currentIndex: 0,
      columns: [],
      data: [],
      scroll: {
        x: 2500,
        y: 680
      },
      timer: null,
      table: null,
      dialog: {
        title: '',
        visible: false,
        record: {},
        changeFlg: false
      },
      currentPage: 1,
      total: 0,
      currentType: ['MAINTAIN'],
      flag: true,
      currentData: [],
      visible: false,
      form: {
        speed: 10,
        rowsPP: 16,
        rows: -1,
        leaveDays: 30,
        replaceWord: '*',
        start: 0,
        end: 0,
        fontSize: 20
      },
      selectedWarningType: [],
      types: [],
      fontSize: '20px',
      isRouteFullscreen: false
    }
  },
  watch: {
    currentType: {
      deep: true,
      async handler(value) {
        this.currentPage = 1
        this.total = 0
        // clearTimeout(this.break)
        this.stopScroll()
        this.currentIndex = this.selectedWarningType.findIndex(item => item.type === value[0])
        this.columns = this.selectedWarningType[this.currentIndex].columns
        await this.getWarningList()
        if (!this.total) {
          this.currentIndex = this.currentIndex === this.selectedWarningType.length - 1 ? 0 : this.currentIndex + 1
          this.currentType = [this.selectedWarningType[this.currentIndex].type]
        } else {
          this.startScroll()
        }
        
      }
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  created() {
    this.setWarningTypes()
    const form = JSON.parse(localStorage.getItem('OVERVIEW_LIST_SETTINGS'))
    if (form) {
      this.form = form
    } else {
      this.form = {
        speed: 10,
        rowsPP: 22,
        rows: -1,
        leaveDays: 30,
        replaceWord: '*',
        start: undefined,
        end: undefined,
        fontSize: 20
      }
    }
    this.fontSize = (isNaN(+this.form.fontSize) ? 20 : this.form.fontSize) + 'px'
  },
  mounted() {
    this.table = document.querySelector('tbody')
    // setTimeout(this.startScroll, 1000)
    this.flexible()
    this.isRouteFullscreen = this.$route.path.startsWith("/fullscreen")
    document.addEventListener("fullscreenchange", this.hanldeFullscreenchange)
  },
  beforeDestroy() {
    this.stopScroll()
    document.removeEventListener("fullscreenchange", this.hanldeFullscreenchange)
    console.log(this.timer)
  },
  methods: {
    async setWarningTypes() {
      try {
        const { data } = await getMenusOfCurrentUser()
        const menu = data.find(r => r.id === 40)
        this.warningType = warningType.filter(w => menu.children.find(m => m.routeName === w.type))
        const types = JSON.parse(localStorage.getItem('warningTypes'))
        if (types) {
          this.selectedWarningType = []
          types.forEach(t => {
            const i = this.warningType.find(wt => wt.type === t)
            if (i) {
              this.selectedWarningType.push(i)
            }
          })
          this.selectedWarningType.sort((a, b) => a.sort - b.sort)
          this.types = types
        } else {
          this.selectedWarningType = this.warningType
          this.types = this.warningType
        }
        if (this.selectedWarningType?.length) {
          this.currentType = [this.selectedWarningType[0].type]
          // this.getWarningList()
        }
      } catch(e) {
        console.log(e)
      }
    },
    flexible () {
      const docEl = document.documentElement
      const dpr = window.devicePixelRatio || 1
      this.setBodyFontSize(dpr)
      this.setRemUnit(docEl)
    },
    setBodyFontSize (dpr) {
      if (document.body) {
        document.body.style.fontSize = (12 * dpr) + 'px'
      } else {
        document.addEventListener('DOMContentLoaded', () => { this.setBodyFontSize(dpr) })
      }
    },
    setRemUnit (docEl, isFullScreen) {
      let rem
      if (isFullScreen) {
        rem = docEl.clientWidth / 20
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20
      }
      docEl.style.fontSize = rem + 'px'
    },
    hanldeFullscreenchange() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      const el = this.$refs.container
      const isFullScreen = document.fullscreenElement !== null
      if (isFullScreen) {
        if (el.clientWidth < window.innerWidth) {
          el.style.width = '98%'
        }
        console.log(el.clientHeight, window.innerHeight);
      } else {
        el.style.width = '1640px'
      }
    },
    async getWarningList() {
      try {
        this.table && (this.table.scrollTop = 0)
        // if(this.currentType[0] === 'maintain') {
        //   const { data } = await compressorApi.getMaintainList()
        //   this.data = data
        // } else {
        //   const { data } = await warningApilistContentAll(this.currentType[0])
        //   this.data = data
        // }
        const { data } = await getWarnData(this.selectedWarningType[this.currentIndex].sort, this.form.rows)
        let result = data
        let replaceWord = this.form.replaceWord
        let start = this.form.start
        let end = this.form.end
        if (replaceWord && ((start || start === 0) || end)) {
          start = start || 1
          result = data.map(d => {
            const c = d.company.split('')
            const e = end ? Math.min(end, c.length) : c.length
            for (let i = (start - 1); i < e; i++) {
              c[i] = replaceWord
            }
            d.company = c.join('')
            return d
          })
        }
        this.data = result
        this.currentData = this.data.slice(0, this.form.rowsPP)
        this.total = Math.ceil(data.length / this.form.rowsPP)
        this.$nextTick(() => {
          const trs = document.querySelectorAll('tr')
          if (this.currentData.length <= 0) return
          if(trs[trs.length - 1].offsetTop + trs[trs.length - 1].clientHeight < this.table.offsetTop + this.table.scrollHeight - 1) {
            trs[trs.length - 1].style.borderBottom = '1px solid #445161'
          }
        })
      } catch(e) {
        console.log(e);
      }
    },
    startScroll() {
      this.timer = setInterval(() => {
        this.currentPage ++
        if(this.currentPage <= this.total) {
          this.currentData = this.data.slice((this.currentPage - 1) * this.form.rowsPP, this.currentPage * this.form.rowsPP)
        } else {
          this.currentIndex = this.currentIndex === this.selectedWarningType.length - 1 ? 0 : this.currentIndex + 1
          this.currentType = [this.selectedWarningType[this.currentIndex].type]
        }
      }, this.form.speed * 1000)
    },
    stopScroll() {
      clearInterval(this.timer)
      this.timer = null
    },
    openSetting() {
      this.stopScroll()
      this.visible = true
    },
    async saveSetting() {
      if ((this.form.end || this.form.end === 0) && this.form.start > this.form.end) {
        return this.$message.warn(this.$t('messages.rri'))
      }
      const tt = this.types.find(t => t === this.selectedWarningType[this.currentIndex].type)
      localStorage.setItem('OVERVIEW_LIST_SETTINGS', JSON.stringify(this.form))
      localStorage.setItem('warningTypes', JSON.stringify(this.types))
      this.fontSize = (isNaN(+this.form.fontSize) ? 20 : this.form.fontSize) + 'px'
      this.visible = false
      this.selectedWarningType = []
      this.types.forEach(t => {
        const i = this.warningType.find(wt => wt.type === t)
        this.selectedWarningType.push(i)
      })
      this.selectedWarningType.sort((a, b) => a.sort - b.sort)
      if (!tt && this.selectedWarningType?.length) {
        this.currentType = [this.selectedWarningType[0].type]
        return
      }
      if (tt) {
        this.currentType = [tt]
      }
    },
    handleCancel() {
      this.visible = false
      this.startScroll()
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  // min-height: 105%;
  // background: url('../../../assets/bg.jpg');
  background-color: #192037;
  // overflow: hidden;
  overflow-x: hidden;
  // font-size: 20px;
  &::-webkit-scrollbar {  /*滚动条整体样式*/
    width: 4px;           /*高宽分别对应横竖滚动条的尺寸*/
    height: 4px;
  }
  &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
    border-radius: 5px;
    background-color: #4961A3;
  }
  &::-webkit-scrollbar-track {  /*滚动条轨道*/
    border-radius: 0;
    background: rgba(0,0,0,0.1);
  }
  .spin {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .header {
    padding-top: 8px;
    margin-bottom: .2083rem;
    .ant-menu {
      background-color: transparent;
      // color: #ccc;
      border-bottom: none;
      color: rgb(19, 25, 47);
    }
    .title {
      height: 40px;
      // background-color: skyblue;
      text-align: center;
      line-height: 40px;
      // font-size: 20px;
      font-weight: 400;
      h1 {
        color: #fff;
      }
    }
    .header-inner {
      height: 100%;
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
  }
  .content {
    width: 100%;
    overflow: auto;
    &::-webkit-scrollbar {  /*滚动条整体样式*/
      width: .1042rem;           /*高宽分别对应横竖滚动条的尺寸*/
      height: .1042rem;
    }
    &::-webkit-scrollbar-thumb {  /*滚动条滑块*/
      border-radius: 5px;
      background-color: #4961A3;
    }
    &::-webkit-scrollbar-track {  /*滚动条轨道*/
      border-radius: 0;
      background: rgba(0,0,0,0.1);
    }
    table {
      width: 98%;
      height: 100%;
      // color: #ccc;
      box-sizing: border-box;
      border: 1px solid #4a5665;
      // border-bottom: none;
      // overflow: hidden;
      margin: 0.8% auto;
      margin-bottom: 0;
      thead {
        // background-color: rgba(19, 25, 47, 0.9);
        background-color: #232c48;
        color: #d7e0fd;
      }
      tbody {
        width: 100%;
        display: block;
        // height: calc(100% - 40px);
        // overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        tr.deep {
          background-color: #232c48;
        }
        tr.shallow {
          background-color: #273051;
        }
      }
      .tbody::-webkit-scrollbar {
        width: 8px;
        // background-color: #ccc;
        border-radius: 4px;
      }
      .tbody::-webkit-scrollbar-track {
        width: 8px;
        // background-color: #ccc;
        border-radius: 4px;
      }
      .tbody::-webkit-scrollbar-thumb {
        width: 8px;
        background-color: #4961A3;
        border-radius: 4px;
      }
      thead,
      tbody tr {
        display: table;
        width: 100%;
        table-layout: fixed;
        color: #d0d9f6;
      }
      // tbody tr td.border {
      //   border-bottom: 1px solid #445161;
      // }
      th,
      td {
        height: 40px;
        padding-left: 15px;
        // font-size: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      th {
        border-right: 1px solid #5b6574;
        // color: #68d8fe;
        line-height: 40px;
      }
      td {
        border-top: 1px solid #445161;
        border-right: 1px solid #445161;
        word-wrap: break-word;
        // color: #61a8ff;
        // font-size: 20px;
      }
      td.companyName,
      td.machineType {
        white-space: nowrap;
        overflow: hidden;//文本超出隐藏
        text-overflow: ellipsis;//文本超出省略号替代
      }
    }
  }
  .ant-menu {
    background-color: transparent;
    border-bottom: none;
    margin-left: 1%;
    color: #ccc;
    font-size: inherit;
  }
}
th {
  font-weight: normal;
}
@media screen and (max-width: 1400px) {
  .dv-decoration-10 {
    width: 28% !important;
  }
  .header .title {
    width: 20% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 30% !important;
    }
    .header .title {
      width: 16% !important;
    }
  }
}
@media screen and (max-width: 1200px) {
  .dv-decoration-10 {
    width: 25% !important;
  }
  .header .title {
    width: 26% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 28% !important;
    }
    .header .title {
      width: 20% !important;
    }
  }
}
@media screen and (max-width: 900px) {
  .dv-decoration-10 {
    width: 20% !important;
  }
  .dv-decoration-8 {
    width: 8% !important;
  }
  .header .title {
    width: 40% !important;
  }
  :-webkit-full-screen {
    .dv-decoration-10 {
      width: 26% !important;
    }
    .header .title {
      width: 24% !important;
    }
  }
}
/deep/ .ant-modal-body {
  padding-bottom: 0;
}

.svgs {
    cursor: pointer;
    path {
      fill: transparent;
    }
    &:hover {
      path {
        fill: #fff;
      }
    }
  }
</style>
